























import { InterventionApi } from "../api/InterventionApi";
import EditionModal from "../core/Modals/EditionModal.vue";
import { Intervention } from "../models/Intervention";
import FacturationModalDisplay from "./InterventionModalPartials/FacturationModalDisplay.vue";
import FacturationModalEdit from "./InterventionModalPartials/FacturationModalEdit.vue";
import { FacturationApi } from "../api/FacturationApi";
import Facturation = Intervention.Facturation;

export default {
    name: "FacturationModal",
    components: {
        FacturationModalEdit,
        FacturationModalDisplay,
        EditionModal,
    },
    props: {
        interventionId: Number,
        forceEditing: Boolean,
    },
    data() {
        return {
            showModal: false,
            intervention: null,
            fetching: true,
            editing: false,
            InterventionApi: new InterventionApi(),
            FacturationApi: new FacturationApi(),
        };
    },
    created() {
        var self = this;
    },
    watch: {
        interventionId: function (newVal): void {
            var self = this;

            self.showModal = _.isNumber(newVal);
            if (self.showModal) {
                self.fetching = true;
                self.InterventionApi.get(self.interventionId, {
                    include: "facturation",
                }).then(function (res) {
                    self.intervention = res;
                    self.fetching = false;
                });
            }
        },
        forceEditing: function (newVal) {
            this.editing = newVal;
        },
    },
    methods: {
        closeModal: function (data): void {
            this.showModal = false;
            this.$emit("close-modal", data);
        },
        saveFacturation: function (): Promise<Facturation> {
            var self = this;
            return self.FacturationApi.save(self.intervention.facturation).then(
                function (res) {
                    self.$emit("data-saved", self.intervention);
                    return res;
                }
            );
        },
    },
};
